import { render, staticRenderFns } from "./TableRekomendasi_izin_praktik_detail.vue?vue&type=template&id=7a5e9fd0&"
import script from "./TableRekomendasi_izin_praktik_detail.vue?vue&type=script&lang=js&"
export * from "./TableRekomendasi_izin_praktik_detail.vue?vue&type=script&lang=js&"
import style0 from "./TableRekomendasi_izin_praktik_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports